<template>
  <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
    <p class="text-gray-600">{{ title }}</p>

    <p class="text-2xl font-bold">
      {{ message }}
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "QualityReportsCardIndicator",
  components: {},
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true
    },

    message: {
      type: String,
      required: true
    }
  },
  created() {},
  computed: {
    hasSlot() {
      return this.$slots;
    }
  },
  methods: {},
  watch: {}
};
</script>
